import SimpleEditor from './SimpleEditor';
import ActionsRenderer from './ActionsRenderer';
import AddRowStatusBar from './AddRowStatusBar';

export default {
    SimpleEditor,
    ActionsRenderer,
    AddRowStatusBar,
}